import defaultApi from '@/utils/request';

export default {
  Load(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_StyleSetting/Load',
      params,
    });
  },
  Get(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_StyleSetting/Get',
      params,
    });
  },
  Add(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_StyleSetting/Add',
      data,
    });
  },
  Update(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_StyleSetting/Update',
      data,
    });
  },
  Delete(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_StyleSetting/Delete',
      data,
      headers: { 'Content-Type': 'application/json-patch+json' },
    });
  },
  SelectStyleData(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_StyleSetting/SelectStyleData',
      params,
    });
  },
};
